/**
 * Human-facing template label (no machine purpose / slug in parentheses).
 */
export function formatTemplateOptionLabel(template) {
  if (!template) return "";
  const name = template.templateName ?? template.name ?? "";
  return String(name).trim();
}

/**
 * Strip noisy placeholders from generated email subjects for UI and sending.
 */
export function sanitizeEmailSubject(subject) {
  if (subject == null || typeof subject !== "string") return subject;
  return subject
    .replace(/\s*-\s*N\/A\s*/gi, " ")
    .replace(/\s*N\/A\s*\(\s*\)/gi, "")
    .replace(/\s*\(\s*\)\s*$/g, "")
    .replace(/\s{2,}/g, " ")
    .trim();
}
